import FlashMessage from 'ember-cli-flash/components/flash-message'
import { FlashType, type CustomFlashMessageObject } from 'district-ui-client/services/flash-queue'
import { on } from '@ember/modifier'
import optional from 'district-ui-client/helpers/optional'
import { t } from 'ember-intl'
import { PhosphorIcon } from 'district-ui-client/components/phosphor-icon'
import Component from '@glimmer/component'

interface Signature {
  Element: Element
  Args: {
    flash: CustomFlashMessageObject
  }
}

export class Toast extends Component<Signature> {
  get variantClasses() {
    switch (this.args.flash.flashType) {
      case FlashType.Default:
        return { borderClass: 'border-l-dusty-black-100', iconClass: 'text-neutral-300' }
      case FlashType.Info:
        return { borderClass: 'border-l-blue-325', iconClass: 'text-blue-325' }
      case FlashType.Caution:
        return { borderClass: 'border-l-juicy-orange-300', iconClass: 'text-juicy-orange-300' }
      case FlashType.Positive:
        return { borderClass: 'border-l-green-300', iconClass: 'text-forest-green-300' }
      case FlashType.Critical:
        return { borderClass: 'border-l-red-300', iconClass: 'text-watermelony-red-300' }
      default:
        return { borderClass: 'border-l-dusty-black-100', iconClass: 'text-neutral-300' }
    }
  }

  <template>
    {{! Note: some styles provided in _flash.css file }}
    <FlashMessage
      data-test-flash-message={{@flash.flashType}}
      @flash={{@flash}}
      class="flash-box-animate-in-out pointer-events-auto flex w-[32rem] translate-x-full gap-4 overflow-hidden rounded-lg border-y border-l-4 border-r border-y-neutral-75 border-r-neutral-75 bg-white p-4 text-neutral-300 shadow-md transition-transform duration-500
        {{this.variantClasses.borderClass}}
        {{if @flash.destroyOnClick 'cursor-pointer'}}"
      ...attributes
      as |_flash_message _flash_object closeAction|
    >
      {{#if @flash.icon}}

        <PhosphorIcon
          data-test-toast-icon={{@flash.icon}}
          @icon={{@flash.icon}}
          class="{{this.variantClasses.iconClass}} mt-0.5 h-5 w-5 flex-shrink-0"
        />
      {{/if}}
      <div class="flex-grow space-y-2">
        {{#if @flash.title}}
          <div data-test-toast-title class="font-medium text-neutral-400">{{@flash.title}}</div>
        {{/if}}
        {{#if @flash.subtitle}}
          <div data-test-toast-subtitle class="flash-box-style-links text-neutral-300">{{@flash.subtitle}}</div>
        {{/if}}
      </div>
      {{#if @flash.showClose}}
        <div class="flex-shrink-0">
          <button data-test-toast-close type="button" aria-label={{t "close"}} {{on "click" (optional closeAction)}}>
            <PhosphorIcon class="h-4 w-4 text-neutral-250" @icon="phosphor-x-bold" />
          </button>
        </div>
      {{/if}}
    </FlashMessage>
  </template>
}
